module.exports = __webpack_public_path__ + "static/media/goal-tgcom24@2x.33675137.png";